// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__1HMC6","log":"ModalInventoryLogs_log__JiOqH","date":"ModalInventoryLogs_date__3Ayi4","userName":"ModalInventoryLogs_userName__1WPQO"};